export default __webpack_public_path__ + "media/images/icons/check-solid-5dcf9568d0b63bd4c8e63f66e4f927d5.svg";